import { Flex, Icon, Text } from '@chakra-ui/react';

const ListItem = ({ title, description, ListIcon, iconText, complete=false, line=false, children }) => {
  return (
    <div className='grid grid-cols-[2rem_1fr] items-start gap-4 relative'>
      <Flex className={`mt-1 h-8 rounded-full border items-center justify-center ${complete ? 'bg-black text-white border-gray-400' : 'bg-gray-100 text-gray-500 border-gray-200'}`}>
        {
          ListIcon ? (
            <Icon as={ListIcon} boxSize={3} />
          ) : (
            iconText
          )
        }
      </Flex>
      {/* This line is now positioned relative to the ListItem itself, allowing it to extend below dynamically. */}
      {line && (
        <div className={`absolute top-[2.25rem] -bottom-7 left-4 w-[1.5px] ${complete ? 'bg-gray-400' : 'bg-gray-200'}`} />
      )}
      <Flex className='flex-col'>
        <Text className='text-base font-medium'>{title}</Text>
        <Text className='text-sm text-gray-500'>{description}</Text>
        {children}
      </Flex>
    </div>
  );
}

export default ListItem;